import { Svg } from '@innovyze/stylovyze/lib/components/Svg';
import { NotificationStatus, SeverityLevel, } from '@innovyze/stylovyze/lib/types';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import ErrorIcon from './Error.svg';
import InfoIcon from './Info.svg';
import SuccessIcon from './Success.svg';
import React from 'react';
export const isActive = (status) => {
    return status === NotificationStatus.ACTIVE;
};
export const isViewed = (status) => {
    return status === NotificationStatus.VIEWED;
};
export const isArchived = (status) => {
    return status === NotificationStatus.ARCHIVED;
};
export const isDeleted = (status) => {
    return status === NotificationStatus.DELETED;
};
export const getNotificationType = (severityLevel) => {
    switch (severityLevel) {
        case SeverityLevel.ERROR:
            return 'error';
        case SeverityLevel.WARNING:
            return 'warning';
        case SeverityLevel.SUCCESS:
            return 'success';
        default:
            return 'primary';
    }
};
export const getNotificationIcon = (severityLevel) => {
    switch (severityLevel) {
        case SeverityLevel.ERROR:
            return React.createElement(Svg, { svg: ErrorIcon });
        case SeverityLevel.WARNING:
            return React.createElement(WarningAmberOutlinedIcon, { color: "warning" });
        case SeverityLevel.SUCCESS:
            return React.createElement(Svg, { svg: SuccessIcon });
        default:
            return React.createElement(Svg, { svg: InfoIcon });
    }
};
